import { Avatar } from "@circle-react-uikit/SkeletonLoader/components/Avatar";
import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

export const ExpandableListItemSkeleton = () => (
  <li
    className="border-primary bg-primary group flex w-full min-w-0 flex-1 gap-x-4 rounded-xl px-6 py-4"
    data-testid="expandable-list-item-skeleton"
  >
    <div style={{ aspectRatio: "1 / 1" }} className="h-10">
      <Avatar />
    </div>

    <div className="flex w-full min-w-0 flex-1 flex-col gap-y-3">
      <div className="flex w-full min-w-0 flex-1 flex-row justify-between gap-y-3">
        <div className="min-w-0 flex-1">
          <div className="flex min-w-0 flex-col gap-y-3">
            <div className="flex flex-col gap-y-1">
              <Row md long />
              <Row sm half />
            </div>

            <div className="flex items-center gap-1">
              <Row xs short />
            </div>
          </div>
        </div>
        <div className="flex w-fit items-start gap-2">
          <Row md className="!h-9 !w-[100px] !rounded-full" />
        </div>
      </div>
    </div>
  </li>
);
